import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import './style/oil-selector-styles.scss';
import WithLangs from './components/WithLangs';
import Book from './components/Book';

ReactDOM.render(
  <Provider store={store}>
  <React.StrictMode>
      <Router basename={process.env.REACT_APP_BASE_PATH_OS}>
        <Routes>
          <Route
            path='*'
            element={
              <WithLangs>
                <App />
              </WithLangs>
            }
          />
          <Route path='/book'element={<Provider store={store}>
            <Book dismiss={function (): void {
              throw new Error('Function not implemented.');
            } } selected={undefined}/>
          </Provider>}/>
        </Routes>
      </Router>
    </React.StrictMode>
   </Provider>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
